module.exports = __webpack_public_path__ + "34bc775d/img/question-icon.06c20c5d.svg";